import { max } from 'lib/array/arrayUtils'

export const getItineraryDaysCount = (
  variation: App.Tours.TourV2OfferVariation,
): number | null => {
  if (!variation.itinerary) return null
  // "Itinerary" here refers to the representation of the tour itinerary, not the Trip Planner itinerary.
  // A tour itinerary item can span multiple days. So to get the total days for the tour, we need to find
  // the start day of the last item, and add its duration.
  const lastItineraryItem = max(variation.itinerary, (item) => item.startDay)
  if (!lastItineraryItem) return null
  const daysCount = lastItineraryItem.startDay + lastItineraryItem.duration - 1
  return daysCount
}
